import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as DOWN } from "../../../assets/icons/filter-down.svg";
import { ReactComponent as UP } from "../../../assets/icons/filter-up.svg";
import "./TranslatorDropdown.css";
import Swal from "sweetalert2";

function TranslatorDropdown({
  order,
  clients,
  handleUpdateTranslator,
  customClass,
  type,
}) {
  const { status,languageFrom, languageTo } = order;
  const [selectedTranslator, setSelectedTranslator] = useState(
    order?.translator?.id || ""
  );
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const filteredClients = clients.filter(client =>
    client.languages && client.languages.length > 0 ? (client.languages.includes(languageFrom) || client.languages.includes(languageTo) )
     : (client.language === languageFrom || client.language === languageTo)
  );

  useEffect(() => {
    if(order && order.translator){
      setSelectedTranslator(order.translator?.id || "");
    }
  }, [order]);

  const handleSelect = async (selectedValue) => {
    if (!selectedValue) return;

    if (order?.translator?.name) {
      const { isConfirmed } = await Swal.fire({
        title: "Are you sure?",
        text: "You want to replace translator?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#12ABBF",
        cancelButtonColor: "#D70015",
        confirmButtonText: "Yes, replace!",
      });

      if (!isConfirmed) return;
    }

    setSelectedTranslator(selectedValue);
    setIsOpen(false);

    const data = filteredClients.find((el) => el.id === selectedValue);

  
    const getRate = () => {

      if (order.expeditedPlus || order.expedited) {
        return data.expeditedRate;
      } else {
        return data.standardRate;
      }
    }

    if (data) {
      handleUpdateTranslator(order, {
        name: data.name,
        id: data.id,
        orderRate: getRate() ?? 0,
      });
    } else {
      console.log("No matching data found");
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const isDisabled =
    status === "created" || status === "cancelled" || status === "Refunded";

  return (
    <div
      className={`custom-dropdown-container ${
        type === "orders" ? " md:w-[200px] w-[200px] " : "xl:w-[200px] w-full "
      }  ${isDisabled ? "disabled" : ""}`}
      ref={dropdownRef}
    >
      <div
        className={`custom-dropdown-header ${customClass} ${
          isOpen && "active"
        }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedTranslator
          ? filteredClients.find((el) => el.id === selectedTranslator)?.name
          : "Сhoose Translator"}
        {isOpen ? (
          <UP className="dropdown-icon" />
        ) : (
          <DOWN className="dropdown-icon" />
        )}
      </div>
      {isOpen && (
        <div className="custom-dropdown-options">
          {filteredClients.map((t) => (
            <div
              key={t.id}
              className="custom-dropdown-option"
              onClick={() => handleSelect(t.id, t.name)}
            >
              {t.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default TranslatorDropdown;
